jQuery(function(){
  // Pricing plans component

  let pricing_card = jQuery('.pricing_card--pricing_plan_cards');
  pricing_card.each(function() {
    let $pricingPlanSelector = jQuery(this).find('.pricing-plans');
    $pricingPlanSelector.select2({
      minimumResultsForSearch: Infinity,
    });

    let $billingInfo =  jQuery(this).find('.billing-info');
    
    let cur = $billingInfo.find('.billing-amount').data('cur');
      $billingInfo.find('.billing-amount').html(cur+$pricingPlanSelector.val());
      $billingInfo.find('.billing-note').html($pricingPlanSelector.find(':selected').data('note'));
      
    $pricingPlanSelector.on('change', function () {
      $billingInfo.find('.billing-amount').html(cur+jQuery(this).val());
      $billingInfo.find('.billing-note').html(jQuery(this).find(':selected').data('note'));
    });
  });

});


// WEBPACK FOOTER //
// ./scripts/components/vog.js